/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Links fiat deposit instruction to account request
 */
export interface AccountFiatDepositInstructionLinkRequest {
  accountId: number;
  fiatDepositInstructionId: number;
}
